import React from "react";
import "./css/PoliciesPages.css";

const Privacy = () => (
  <div className="policies-container">
    <div className="policies-content">
      <div className="policies-header">
        <h1 className="policies-title">Privacy Policy</h1>
        <p className="policies-date">
          <strong>Effective Date:</strong> May 12, 2026
        </p>
      </div>

      <p className="policies-intro">
        Welcome to TasteBuds Social ("TasteBuds Social," "we," "our," or "us").
        This Privacy Policy explains how we collect, use, and protect your
        information when you use TasteBuds Social.
      </p>

      <section className="policy-section">
        <h2>Information We Collect</h2>
        <ul>
          <li>Information you submit (e.g., reviews, photos, profile info)</li>
          <li>
            Location information (if you allow it, for local discovery features)
          </li>
          <li>
            Device and usage information (device type, OS, app usage, crash
            data)
          </li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>How We Use Information</h2>
        <ul>
          <li>To provide and improve TasteBuds Social</li>
          <li>To display relevant content near you</li>
          <li>To maintain and enhance the service</li>
          <li>If required by law</li>
          <li>To protect users, rights, or platform security</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>Public Content</h2>
        <p>
          Public content such as usernames, reviews, and uploaded photos may be
          visible to other users.
        </p>
      </section>

      <section className="policy-section">
        <h2>Data Retention</h2>
        <p>
          We retain information for as long as necessary to provide the service
          and comply with legal obligations.
        </p>
        <p>
          You may request deletion of your account and associated data by
          contacting:{" "}
          <a href="mailto:support@tastebuds.social">support@tastebuds.social</a>
        </p>
      </section>

      <section className="policy-section">
        <h2>Children's Privacy</h2>
        <p>
          TasteBuds Social is not directed to children under 13. We do not
          knowingly collect personal information from children under 13.
        </p>
      </section>

      <section className="policy-section">
        <h2>Security</h2>
        <p>
          We use reasonable safeguards to protect user information, but no
          system can be guaranteed 100% secure.
        </p>
      </section>

      <section className="policy-section">
        <h2>Your Rights</h2>
        <ul>
          <li>Access your data</li>
          <li>Correct your data</li>
          <li>Delete your data</li>
          <li>Withdraw permissions such as location access</li>
        </ul>
        <p>
          To make a request, contact:{" "}
          <a href="mailto:support@tastebuds.social">support@tastebuds.social</a>
        </p>
      </section>

      <section className="policy-section">
        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Continued use of
          the app after updates constitutes acceptance of the revised policy.
        </p>
      </section>

      <section className="policy-section last-section">
        <h2>Contact</h2>
        <p>
          TasteBuds Social
          <br />
          support@tastebuds.social
          <br />
          tastebuds.social
        </p>
      </section>
    </div>
  </div>
);

export default Privacy;
